var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Input from '../BasicInput';
import Button from '../../../Button';
import getIconSet from '../../../utils/getIconSet';
var ArrowButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  font-size: 0.5rem;\n  border: 0px none;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  cursor: pointer;\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:disabled > * {\n    opacity: 0.5;\n  }\n\n  &:disabled:hover,\n  &:disabled:active {\n    background: unset;\n  }\n"], ["\n  flex: 1;\n  font-size: 0.5rem;\n  border: 0px none;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  cursor: pointer;\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:disabled > * {\n    opacity: 0.5;\n  }\n\n  &:disabled:hover,\n  &:disabled:active {\n    background: unset;\n  }\n"])));
var ButtonContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var IncrementButton = styled(ArrowButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &,\n  &:hover,\n  &:focus {\n    border-bottom: none;\n    border-top-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n"], ["\n  &,\n  &:hover,\n  &:focus {\n    border-bottom: none;\n    border-top-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n"])));
var DecrementButton = styled(ArrowButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &,\n  &:hover,\n  &:focus {\n    border-top: none;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n"], ["\n  &,\n  &:hover,\n  &:focus {\n    border-top: none;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n"])));
var roundValue = function (value, step) {
    var _a = step.toString().split('.'), _b = _a[1], decimalPlace = _b === void 0 ? '' : _b;
    var decimals = Math.pow(10, decimalPlace.length);
    return Math.round(value * decimals) / decimals;
};
var confineValue = function (value, step, min, max) {
    var confinedValue = value;
    if (typeof min === 'number') {
        confinedValue = roundValue(Math.max(min, Number(confinedValue)), step);
    }
    if (typeof max === 'number') {
        confinedValue = roundValue(Math.min(max, Number(confinedValue)), step);
    }
    return confinedValue;
};
var _a = getIconSet(), ArrowUp = _a.ArrowLargeUp, ArrowDown = _a.ArrowLargeDown;
var ChangeButtons = function (_a) {
    var onIncrement = _a.onIncrement, onDecrement = _a.onDecrement;
    return (React.createElement(ButtonContainer, null,
        React.createElement(IncrementButton, { onClick: onIncrement },
            React.createElement(ArrowUp, { size: "1rem" })),
        React.createElement(DecrementButton, { onClick: onDecrement },
            React.createElement(ArrowDown, { size: "1rem" }))));
};
var NumberInput = function (_a) {
    var max = _a.max, _b = _a.min, min = _b === void 0 ? 0 : _b, _c = _a.onValueChange, onValueChange = _c === void 0 ? function (_value) { return null; } : _c, // eslint-disable-line @typescript-eslint/no-unused-vars
    _d = _a.onChange, // eslint-disable-line @typescript-eslint/no-unused-vars
    onChange = _d === void 0 ? function (_e) { return null; } : _d, // eslint-disable-line @typescript-eslint/no-unused-vars
    _f = _a.step, // eslint-disable-line @typescript-eslint/no-unused-vars
    step = _f === void 0 ? 1 : _f, value = _a.value, props = __rest(_a, ["max", "min", "onValueChange", "onChange", "step", "value"]);
    var _g = useState(value), currentValue = _g[0], setCurrentValue = _g[1];
    var onIncrement = function () { return setCurrentValue(currentValue + step); };
    var onDecrement = function () { return setCurrentValue(currentValue - step); };
    useEffect(function () {
        var calculatedValue = confineValue(currentValue, step, min, max);
        setCurrentValue(calculatedValue);
        onValueChange(calculatedValue);
    }, [currentValue, step, min, max]);
    return (React.createElement(Input, __assign({ buttonContent: React.createElement(ChangeButtons, { onDecrement: onDecrement, onIncrement: onIncrement }), onChange: function (e) {
            setCurrentValue(Number(e.target.value));
            onChange(e);
        }, type: "number", value: currentValue, min: min, max: max, step: step }, props)));
};
export default NumberInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map